package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.DnsW500Rounded: ImageVector
    get() {
        if (_dnsW500Rounded != null) {
            return _dnsW500Rounded!!
        }
        _dnsW500Rounded = Builder(name = "DnsW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(300.0f, 230.43f)
                quadToRelative(-25.0f, 0.0f, -42.5f, 17.5f)
                reflectiveQuadToRelative(-17.5f, 42.5f)
                quadToRelative(0.0f, 25.0f, 17.5f, 42.5f)
                reflectiveQuadToRelative(42.5f, 17.5f)
                quadToRelative(25.0f, 0.0f, 42.5f, -17.5f)
                reflectiveQuadToRelative(17.5f, -42.5f)
                quadToRelative(0.0f, -25.0f, -17.5f, -42.5f)
                reflectiveQuadToRelative(-42.5f, -17.5f)
                close()
                moveTo(300.0f, 646.7f)
                quadToRelative(-25.0f, 0.0f, -42.5f, 17.5f)
                reflectiveQuadTo(240.0f, 706.7f)
                quadToRelative(0.0f, 25.0f, 17.5f, 42.5f)
                reflectiveQuadToRelative(42.5f, 17.5f)
                quadToRelative(25.0f, 0.0f, 42.5f, -17.5f)
                reflectiveQuadToRelative(17.5f, -42.5f)
                quadToRelative(0.0f, -25.0f, -17.5f, -42.5f)
                reflectiveQuadTo(300.0f, 646.7f)
                close()
                moveTo(157.37f, 102.3f)
                horizontalLineToRelative(645.26f)
                quadToRelative(19.34f, 0.0f, 32.42f, 13.3f)
                quadToRelative(13.08f, 13.29f, 13.08f, 32.68f)
                verticalLineToRelative(283.35f)
                quadToRelative(0.0f, 19.95f, -13.08f, 33.44f)
                quadToRelative(-13.08f, 13.5f, -32.42f, 13.5f)
                lineTo(157.37f, 478.57f)
                quadToRelative(-19.34f, 0.0f, -32.42f, -13.5f)
                quadToRelative(-13.08f, -13.49f, -13.08f, -33.44f)
                verticalLineToRelative(-283.35f)
                quadToRelative(0.0f, -19.39f, 13.08f, -32.68f)
                quadToRelative(13.08f, -13.3f, 32.42f, -13.3f)
                close()
                moveTo(202.87f, 193.3f)
                verticalLineToRelative(194.26f)
                horizontalLineToRelative(554.26f)
                lineTo(757.13f, 193.3f)
                lineTo(202.87f, 193.3f)
                close()
                moveTo(157.37f, 518.57f)
                horizontalLineToRelative(645.26f)
                quadToRelative(19.34f, 0.0f, 32.42f, 13.49f)
                quadToRelative(13.08f, 13.49f, 13.08f, 33.44f)
                verticalLineToRelative(283.35f)
                quadToRelative(0.0f, 19.44f, -13.08f, 32.59f)
                quadToRelative(-13.08f, 13.15f, -32.42f, 13.15f)
                lineTo(157.37f, 894.59f)
                quadToRelative(-19.34f, 0.0f, -32.42f, -13.15f)
                quadToRelative(-13.08f, -13.15f, -13.08f, -32.59f)
                lineTo(111.87f, 565.5f)
                quadToRelative(0.0f, -19.95f, 13.08f, -33.44f)
                quadToRelative(13.08f, -13.49f, 32.42f, -13.49f)
                close()
                moveTo(202.87f, 609.57f)
                verticalLineToRelative(194.02f)
                horizontalLineToRelative(554.26f)
                verticalLineToRelative(-194.02f)
                lineTo(202.87f, 609.57f)
                close()
                moveTo(202.87f, 193.3f)
                verticalLineToRelative(194.26f)
                verticalLineToRelative(-194.26f)
                close()
                moveTo(202.87f, 609.57f)
                verticalLineToRelative(194.02f)
                verticalLineToRelative(-194.02f)
                close()
            }
        }
        .build()
        return _dnsW500Rounded!!
    }

private var _dnsW500Rounded: ImageVector? = null
